import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { Metamodel } from 'app/model/base/model';
import { BitbucketTableDataset } from 'app/model/dataset/bitbucket.dataset';
import { BitbucketLinkedService } from 'app/model/linkedservice/bitbucket.linkedservice';
import { GlobalVariables } from 'app/services/globals';

export const bitbucketTableMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(BitbucketTableDataset).name,
    displayName: 'Bitbucket',
    disabled: !GlobalVariables.enableBitbucketConnector,
    supportLinkedServiceTypes: [Metamodel.modelFor(BitbucketLinkedService).name],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-REST'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    notSupportCopySourceQuery: true,
    category: ['ServicesApps'],
    isTableRequired: true,
    splitTablePath: true,
    schemaAlias: 'schema',
    tableAlias: 'table',
    copySourceControls: [
        {
            type: 'parameterizable',
            child: {
                type: 'textbox-number',
                bind: 'batchSize',
                label: stringResources.ModelName_BatchSize,
                min: 1,
                inputType: 'number'
            },
            dynamicContentTextClass: 'input-spaced'
        }
    ]
};
